import { cEl } from '../../../../util';
import {
    getCurrTest,
    getNextTest,
    getPrevTest,
    getTestList,
    orderedTest,
    setCurrTest,
    setTestList,
    testToStep,
} from '../constants';
import { testRenderer } from '../index';

function QuestionFooter() {
    const { key, questionNum, totalScore, selectedAnswers } = getCurrTest();
    const currentQuestions = testToStep[key];
    const currentQuestion = currentQuestions[questionNum];

    const footer = cEl('div');
    footer.classList.add('question-footer');

    const prevButton = cEl('button');
    prevButton.classList.add('button', 'prev-button');
    prevButton.innerHTML = '< 이전 문항';
    if (getTestList()[0].key === key && questionNum === 0) {
        prevButton.classList.add('display-none');
    }
    prevButton.addEventListener('click', () => {
        if (questionNum === 0) {
            const prevTest = getPrevTest(key, getTestList());
            if (prevTest?.key) {
                setCurrTest({
                    ...prevTest,
                    totalScore: prevTest.totalScore.slice(0, -1),
                    selectedAnswers: prevTest.selectedAnswers.slice(0, -1),
                });
            }
        } else {
            let prevQuestionNum = questionNum - 1;
            const prevTotalScore = [...totalScore];
            const prevSelectedAnswers = [...selectedAnswers];
            const lastScore = prevTotalScore.pop();
            prevSelectedAnswers.pop();
            if (lastScore === null) {
                prevTotalScore.pop();
                prevSelectedAnswers.pop();
                prevQuestionNum -= 1;
            }
            setCurrTest({
                ...getCurrTest(),
                questionNum: prevQuestionNum,
                totalScore: prevTotalScore,
                selectedAnswers: prevSelectedAnswers,
            });
        }
        testRenderer(getCurrTest());
    });

    const nextButton = cEl('button');
    nextButton.classList.add('button', 'next-button');
    if (!currentQuestion.answers.length) {
        nextButton.classList.add('active');
    } else {
        nextButton.disabled = true;
    }
    nextButton.innerHTML = '다음 문항 >';
    nextButton.addEventListener('click', () => {
        const selected = [];
        if (!currentQuestion.answers.length) {
            selected.push({ score: 0 });
        } else {
            const selectedElement = document.querySelectorAll('.answer.selected');
            selectedElement.forEach((el, i) => {
                selected.push(el.dataset);
            });
        }
        if (selected[0]) {
            if (typeof currentQuestion.handleNextQuestion === 'function') {
                currentQuestion.handleNextQuestion(selected);
            } else {
                if (questionNum + 1 < currentQuestions.length) {
                    setCurrTest({
                        ...getCurrTest(),
                        questionNum: questionNum + 1,
                        totalScore: [...totalScore, Number(selected[0].score)],
                        selectedAnswers: [...selectedAnswers, getAnswerNum(getCurrTest(), selected[0].key)],
                    });
                } else {
                    setTestList(
                        getTestList().map(testInfo => {
                            if (testInfo.key === key) {
                                return {
                                    ...getCurrTest(),
                                    totalScore: [...totalScore, Number(selected[0].score)],
                                    selectedAnswers: [...selectedAnswers, getAnswerNum(getCurrTest(), selected[0].key)],
                                };
                            }
                            return testInfo;
                        }),
                    );

                    const nextTest = getNextTest(key, getTestList());
                    if (nextTest?.key) {
                        setCurrTest({ ...nextTest });
                    } else {
                        setCurrTest({ ...orderedTest[orderedTest.length - 1] });
                    }
                }
                testRenderer(getCurrTest());
            }
        }
    });

    footer.append(prevButton, nextButton);

    return footer;
}

export const getAnswerNum = (test, answerKey) => {
    if (testToStep[test.key]?.[test.questionNum]?.answers) {
        return testToStep[test.key][test.questionNum].answers.findIndex(answer => answer.key === answerKey) + 1;
    }
    return null;
};

export default QuestionFooter;
